import { AxiosResponse } from 'axios';
import { app } from '@/main';

import { Pagination } from '@/models/general';

import APIService from '../api';

export default class BillingService extends APIService {
  toggleBillingSubscription(businessId: string, active: boolean) {
    return this.post(`/billing/subscription/${businessId}`, {
      active
    });
  }

  getTwismBillingActivity(businessId: string, url?: string) {
    return this.get(url || `/billing/payment/${businessId}`);
  }

  getBillingSubscription(businessId: string) {
    return this.get(`/billing/subscription/${businessId}`);
  }

  getBillingOverviewSubscription() {
    return this.get('/admin/billing/subscription');
  }

  getBillingOverview() {
    return this.get('/admin/billing/overview');
  }

  getListActivities(
    resource: string = '/admin/billing/activity',
    params: Record<string, any> = {}
  ): Promise<AxiosResponse<Pagination<any>>> {
    return this.get<Pagination<any>>(resource, {
      params
    });
  }

  async getOverviewAndActivedFeatures(notLoadFeatures?: boolean) {
    const { data: overview } = await this.getBillingOverviewSubscription();
    let features: any = {};

    app.$store.dispatch('business/SET_BILLING_SUBSCRIPTION', overview);

    if (!notLoadFeatures) {
      const { data: featuresData } = await this.getActivedFeatures();
      features = featuresData;
    }

    return { features, overview };
  }

  getActivedFeatures() {
    return this.get('/admin/billing/features');
  }

  activateSubscription(source?: string) {
    return this.post('/admin/billing/subscription', source ? { source } : {});
  }

  deactivateSubscription() {
    return this.delete('/admin/billing/subscription');
  }

  acceptTermsSubscription() {
    return this.post('/admin/billing/terms', { accepted: true });
  }
}
